import { render, staticRenderFns } from "./actividad-seleccion-multi.vue?vue&type=template&id=f5b038e8&scoped=true&"
import script from "./actividad-seleccion-multi.vue?vue&type=script&lang=js&"
export * from "./actividad-seleccion-multi.vue?vue&type=script&lang=js&"
import style0 from "./actividad-seleccion-multi.vue?vue&type=style&index=0&id=f5b038e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b038e8",
  null
  
)

export default component.exports